var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSouthKorea = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30157)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 7.5C14.5 11.366 11.366 14.5 7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5Z",
  fill: "#F0F0F0",
  stroke: "#D8E5F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.109 7.49931C10.109 8.15148 8.94102 9.78191 7.50028 9.78191C6.05955 9.78191 4.8916 8.15148 4.8916 7.49931C4.8916 6.05854 6.05955 4.89062 7.50028 4.89062C8.94102 4.89062 10.109 6.05854 10.109 7.49931Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.109 7.5C10.109 8.94076 8.94102 10.1087 7.50028 10.1087C6.05955 10.1087 4.8916 8.94076 4.8916 7.5",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2646 9.80664L10.9563 9.11502L11.4174 9.57611L10.7257 10.2677L10.2646 9.80664Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.1123 10.959L9.80393 10.2674L10.265 10.7285L9.57339 11.4201L9.1123 10.959Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6484 11.1895L12.3401 10.4978L12.8012 10.9589L12.1095 11.6505L11.6484 11.1895Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4952 12.3418L11.1869 11.6502L11.648 12.1113L10.9563 12.8029L10.4952 12.3418Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9561 10.498L11.6477 9.80642L12.1088 10.2675L11.4171 10.9591L10.9561 10.498Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8038 11.6504L10.4954 10.9588L10.9565 11.4199L10.2649 12.1115L9.8038 11.6504Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6513 5.19531L9.80697 3.35097L10.2681 2.88988L12.1124 4.73422L11.6513 5.19531Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.80661 4.73438L9.11499 4.04275L9.57606 3.58168L10.2677 4.27331L9.80661 4.73438Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.959 5.88672L10.2674 5.19509L10.7284 4.73403L11.4201 5.42565L10.959 5.88672Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1895 3.35156L10.4978 2.65994L10.9589 2.19885L11.6505 2.89047L11.1895 3.35156Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3428 4.50391L11.6511 3.81228L12.1122 3.35119L12.8039 4.04282L12.3428 4.50391Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.65918 10.4961L4.50352 12.3404L4.04243 12.8015L2.19809 10.9572L2.65918 10.4961Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.50305 10.957L5.19468 11.6487L4.73361 12.1097L4.04198 11.4181L4.50305 10.957Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.35059 9.80469L4.04221 10.4963L3.58112 10.9574L2.8895 10.2658L3.35059 9.80469Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.04199 9.11328L5.88633 10.9576L5.42524 11.4187L3.5809 9.57437L4.04199 9.11328Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.50293 2.6582L2.65859 4.50254L2.1975 4.04145L4.04184 2.19711L4.50293 2.6582Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.19434 3.34961L3.35 5.19395L2.88891 4.73286L4.73325 2.88852L5.19434 3.34961Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.88672 4.04102L4.04238 5.88535L3.58131 5.42428L5.42565 3.57995L5.88672 4.04102Z",
  fill: "black"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30157"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSouthKorea);
export { ForwardRef as ReactComponent };